<template><div><h1 id="mahntexte" tabindex="-1"><a class="header-anchor" href="#mahntexte"><span>Mahntexte</span></a></h1>
<p>Mahntexte — Definition von Mahntexten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Tabelle, welche die zu verwendenden Schärfecodes und Mahntexte definiert. Abhängig von den Einstellungen unter Debitorenverwaltung &gt; Mahnwesen wird entsprechend dem gewählten Schärfecode und abhängig vom Sprachcode der Adresse der Mahntext in den Ausdruck übernommen.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Mahnungen → Mahntexte</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Schärfecode</dt>
<dd>Bezeichnung Schärfecode, 1-stellig, alphanumerisch</dd>
<dt>Sprachcode</dt>
<dd>Sprachcode, für den der Mahntext gilt (Sprachcode wird nicht validiert)</dd>
<dt>Kurzbezeichnung</dt>
<dd>Bezeichnung des Schärfecodes</dd>
<dt>Text</dt>
<dd>Mahntext, der auf das Formular gedruckt wird</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/buchhaltung/debitorenverwaltung.html" title="Kapitel 6. Buchhaltung">Buchhaltung</RouteLink>--&gt;</p>
</div></template>


